import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNote1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconNote1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V14.5H15.25C14.8358 14.5 14.5 14.8358 14.5 15.25V21H3.75C3.33579 21 3 20.6642 3 20.25V3.75Z" fill="currentColor"/><Path d="M16 21C16.1989 21 16.3897 20.921 16.5303 20.7803L20.7803 16.5303C20.921 16.3897 21 16.1989 21 16H16V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNote1;
